import { toPublicMediaUrl, CDN_ORIGIN, LEGACY_OSS_ORIGIN } from '@/utils/publicMediaUrl'

const THUMBNAIL_PROCESS = 'image/resize,m_lfit,w_640,h_640/quality,q_80/format,webp'
const CARD_THUMBNAIL_PROCESS = 'image/resize,m_lfit,w_480,h_480/quality,q_80/format,webp'
const COMPACT_THUMBNAIL_PROCESS = 'image/resize,m_lfit,w_64,h_64/quality,q_70/format,webp'

export function assetDisplayUrl(asset) {
  return asset?.displayUrl || asset?.yyUrl?.trim() || asset?.sourceUrl || asset?.volcUrl || ''
}

// List cards never fall back to a full image, MinIO, or a provider URL.
// Keep the original resource address exclusively for explicit viewing/downloads.
export function assetCardThumbnailUrl(asset) {
  for (const source of [asset?.thumbnailSourceUrl, asset?.sourceUrl, asset?.displayUrl, asset?.yyUrl, asset?.volcUrl]) {
    if (typeof source !== 'string' || !source.trim()) continue
    const thumbnail = assetThumbnailUrl(source.trim(), { knownImage: asset?.assetType === 'Image', card: true })
    try {
      const url = new URL(thumbnail)
      if (url.origin === CDN_ORIGIN && !url.username && !url.password && !url.hash &&
        [...url.searchParams.keys()].length === 1 &&
        [CARD_THUMBNAIL_PROCESS, THUMBNAIL_PROCESS].includes(url.searchParams.get('x-oss-process'))) {
        return `${url.origin}${url.pathname}?x-oss-process=${CARD_THUMBNAIL_PROCESS}`
      }
    } catch (_) { /* No supported CDN thumbnail: leave the card placeholder visible. */ }
  }
  return ''
}

// Only transform unsigned, unprocessed public images. Preview/download keep the original.
// Verified asset types cover extensionless OSS keys created by Feishu synchronization.
export function assetThumbnailUrl(value, { knownImage = false, compact = false, card = false } = {}) {
  const original = toPublicMediaUrl(value)
  try {
    const url = new URL(original)
    if (![CDN_ORIGIN, LEGACY_OSS_ORIGIN].includes(url.origin) || url.search || url.hash ||
      url.username || url.password || (!knownImage && !/\.(?:jpe?g|png|webp|bmp)$/i.test(url.pathname))) return original
    return `${original}?x-oss-process=${compact ? COMPACT_THUMBNAIL_PROCESS : card ? CARD_THUMBNAIL_PROCESS : THUMBNAIL_PROCESS}`
  } catch (_) { return original }
}
